import { getWorkspacesByUserId } from '../workspaces'
import type { Workspace } from '../workspaces.type'

let inFlight: Promise<Workspace[]> | null = null

export function resetWorkspacesFetchDedupedInFlight(): void {
  inFlight = null
}

/**
 * Deduplicates concurrent calls to the session-scoped GetWorkspacesByUserId fetch while the list
 * is being loaded (e.g. Strict Mode double effects + init + page effects).
 */
export function getWorkspacesByUserIdDeduped(): Promise<Workspace[]> {
  if (!inFlight) {
    inFlight = getWorkspacesByUserId().finally(() => {
      inFlight = null
    })
  }
  return inFlight
}
